import { render, staticRenderFns } from "./NewClientModal.vue?vue&type=template&id=4cfd5e81&scoped=true&"
import script from "./NewClientModal.vue?vue&type=script&lang=js&"
export * from "./NewClientModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfd5e81",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/zp_frontend_vuejs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cfd5e81')) {
      api.createRecord('4cfd5e81', component.options)
    } else {
      api.reload('4cfd5e81', component.options)
    }
    module.hot.accept("./NewClientModal.vue?vue&type=template&id=4cfd5e81&scoped=true&", function () {
      api.rerender('4cfd5e81', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Modals/NewClientModal.vue"
export default component.exports